import { render, staticRenderFns } from "./CallTimeSingleList.vue?vue&type=template&id=52f274b2&scoped=true&"
import script from "./CallTimeSingleList.vue?vue&type=script&lang=js&"
export * from "./CallTimeSingleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f274b2",
  null
  
)

export default component.exports